import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption, RadioLayoutType, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { DomainType } from '../../types/DomainType';

export type DomainTypeSelectorProps = Readonly<{
    onDomainTypeChange: (domainType: DomainType) => void;
    domainType: DomainType;
    isEditDomainDialog: boolean;
}>;

export function DomainTypeSelector(props: DomainTypeSelectorProps) {
    const domainTypenOptions: RadioButtonWithLabelOption<DomainType>[] = [
        {
            value: DomainType.DOMAIN,
            testId: 'Domain',
            label: Messages.dataConnectSiteSettingsDomainTypeDomain()
        },
        {
            value: DomainType.FILESERVER,
            testId: 'file_server',
            label: Messages.dataConnectSiteSettingsDomainTypeFileServer()
        },
    ];

    return (
        props.isEditDomainDialog ? <></> :
        <RadioButtonWithLabelGroupWidget
            label={Messages.dataConnectSiteSettingsDomainType()}
            buttonList={domainTypenOptions}
            checkedIndex={props.domainType === DomainType.DOMAIN ? 0 : 1 }
            handleChange={props.onDomainTypeChange}
            layout={RadioLayoutType.Veritical}
            className={selectFieldClass}
        />
    );
}

const selectFieldClass = cssClass('add-new-domain-type-field', 'root', {
  width: '100%',
  marginBottom: TabStyles.Spacing.LargeSpace,
});
